"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLogoMenuSurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 56,
    viewBox: "0 0 86 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M59.9835 29.9582C59.9835 31.1004 59.0576 32.0263 57.9154 32.0263C56.7732 32.0263 55.8473 31.1004 55.8473 29.9582C55.8473 28.8161 56.7732 27.8901 57.9154 27.8901C59.0576 27.8901 59.9835 28.8161 59.9835 29.9582Z",
    fill: "#012230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2123 21.5955C72.2123 22.7874 71.2461 23.7535 70.0543 23.7535C68.8624 23.7535 67.8962 22.7874 67.8962 21.5955C67.8962 20.4037 68.8624 19.4375 70.0543 19.4375C71.2461 19.4375 72.2123 20.4037 72.2123 21.5955Z",
    fill: "#012230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4629 14.5826C82.4629 15.9731 81.3357 17.1003 79.9452 17.1003C78.5547 17.1003 77.4275 15.9731 77.4275 14.5826C77.4275 13.1921 78.5547 12.0649 79.9452 12.0649C81.3357 12.0649 82.4629 13.1921 82.4629 14.5826Z",
    fill: "#012230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6321 37.0616C50.6321 38.4521 49.5049 39.5793 48.1144 39.5793C46.7239 39.5793 45.5967 38.4521 45.5967 37.0616C45.5967 35.6712 46.7239 34.5439 48.1144 34.5439C49.5049 34.5439 50.6321 35.6712 50.6321 37.0616Z",
    fill: "#012230"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M64.0001 4.51203C62.8361 4.51203 61.8925 5.45564 61.8925 6.61964C61.8925 7.78363 62.8361 8.72724 64.0001 8.72724C65.1641 8.72724 66.1077 7.78363 66.1077 6.61964C66.1077 5.45564 65.1641 4.51203 64.0001 4.51203ZM57.9361 6.61964C57.9361 3.2706 60.651 0.555664 64.0001 0.555664C67.3491 0.555664 70.0641 3.2706 70.0641 6.61964C70.0641 9.96867 67.3491 12.6836 64.0001 12.6836C60.651 12.6836 57.9361 9.96867 57.9361 6.61964Z",
    fill: "#01B0C1"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M64.0001 42.9033C62.8361 42.9033 61.8925 43.8469 61.8925 45.0109C61.8925 46.1749 62.8361 47.1185 64.0001 47.1185C65.1641 47.1185 66.1077 46.1749 66.1077 45.0109C66.1077 43.8469 65.1641 42.9033 64.0001 42.9033ZM57.9361 45.0109C57.9361 41.6618 60.651 38.9469 64.0001 38.9469C67.3491 38.9469 70.0641 41.6618 70.0641 45.0109C70.0641 48.3599 67.3491 51.0749 64.0001 51.0749C60.651 51.0749 57.9361 48.3599 57.9361 45.0109Z",
    fill: "#01B0C1"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M48.064 12.4799C46.9 12.4799 45.9564 13.4235 45.9564 14.5875C45.9564 15.7515 46.9 16.6951 48.064 16.6951C49.228 16.6951 50.1716 15.7515 50.1716 14.5875C50.1716 13.4235 49.228 12.4799 48.064 12.4799ZM42 14.5875C42 11.2385 44.7149 8.52355 48.064 8.52355C51.413 8.52355 54.1279 11.2385 54.1279 14.5875C54.1279 17.9366 51.413 20.6515 48.064 20.6515C44.7149 20.6515 42 17.9366 42 14.5875Z",
    fill: "#01B0C1"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M79.936 12.4799C78.772 12.4799 77.8284 13.4235 77.8284 14.5875C77.8284 15.7515 78.772 16.6951 79.936 16.6951C81.1 16.6951 82.0436 15.7515 82.0436 14.5875C82.0436 13.4235 81.1 12.4799 79.936 12.4799ZM73.8721 14.5875C73.8721 11.2385 76.587 8.52355 79.936 8.52355C83.2851 8.52355 86 11.2385 86 14.5875C86 17.9366 83.2851 20.6515 79.936 20.6515C76.587 20.6515 73.8721 17.9366 73.8721 14.5875Z",
    fill: "#01B0C1"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M79.936 34.9354C78.772 34.9354 77.8284 35.879 77.8284 37.043C77.8284 38.207 78.772 39.1506 79.936 39.1506C81.1 39.1506 82.0436 38.207 82.0436 37.043C82.0436 35.879 81.1 34.9354 79.936 34.9354ZM73.8721 37.043C73.8721 33.694 76.587 30.979 79.936 30.979C83.2851 30.979 86 33.694 86 37.043C86 40.392 83.2851 43.107 79.936 43.107C76.587 43.107 73.8721 40.392 73.8721 37.043Z",
    fill: "#01B0C1"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M48.064 34.9354C46.9 34.9354 45.9564 35.879 45.9564 37.043C45.9564 38.207 46.9 39.1506 48.064 39.1506C49.228 39.1506 50.1716 38.207 50.1716 37.043C50.1716 35.879 49.228 34.9354 48.064 34.9354ZM42 37.043C42 33.694 44.7149 30.979 48.064 30.979C51.413 30.979 54.1279 33.694 54.1279 37.043C54.1279 40.392 51.413 43.107 48.064 43.107C44.7149 43.107 42 40.392 42 37.043Z",
    fill: "#01B0C1"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M59.6748 45.7361L51.3159 41.6057L53.0686 38.0587L61.4275 42.1892L59.6748 45.7361Z",
    fill: "#01B0C1"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M59.543 5.73549L51.3289 9.83711L53.0964 13.3767L61.3104 9.27511L59.543 5.73549Z",
    fill: "#01B0C1"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M77.6896 32.7771L52.6699 15.1646L50.3926 18.3998L75.4122 36.0123L77.6896 32.7771Z",
    fill: "#01B0C1"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M67.5975 42.0928L75.4975 38.1713L77.2566 41.7151L69.3566 45.6366L67.5975 42.0928Z",
    fill: "#01B0C1"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M75.4778 13.2877L77.2545 9.75266L69.3653 5.78762L67.5887 9.32262L75.4778 13.2877Z",
    fill: "#01B0C1"
  }));
}

var _default = SvgLogoMenuSurance;
exports["default"] = _default;